<template>
  <transition name="modal">
    <div class="modal-mask" @click="closeModal($event)">
      <div class="modal-wrapper" id="wrapper">
        <div class="modal-container">
          <div class="option-container">
            <h6>
              You've chosen to proceed without voting, please pick an option
              below:
            </h6>

            <p v-if="hasCandidates && preventProxyDeferrals">
              This tool does not currently support assigning authority to your
              proxyholder to make specific voting decisions on your behalf.
              Please contact management for a paper proxy if you wish to do so.
            </p>

            <question-button
              color="primary"
              text="Abstain from voting"
              @button-clicked="
                trackOption(
                  'I abstain from voting and my proxy shall not vote on this matter'
                )
              "
            ></question-button>

            <!-- Allow proxy deferrals if no candidates exist, or if Proxy Deferrals are enabled -->
            <question-button
              v-if="!hasCandidates || !preventProxyDeferrals"
              color="primary"
              text="Allow my proxy to choose"
              @button-clicked="
                trackOption('I give my proxy authority to vote on this matter')
              "
            ></question-button>

            <br />

            <button class="mdl-button mdl-js-button" @click="closeModalButton">
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import QuestionButton from '@/components/Questions/QuestionsButton';
import ToggleListItem from '@/components/Questions/ToggleListItem.vue';
import {mapActions} from 'vuex';

import _ from 'lodash';

export default {
  name: 'OptionModal',
  components: {
    QuestionButton,
    ToggleListItem
  },
  props: {
    questionId: {
      type: [String, Number],
      required: true
    },
    votes: {
      type: Array,
      default() {
        return [];
      }
    },
    preventProxyDeferrals: {
      type: Boolean,
      default: true
    },
    hasCandidates: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    voteEmpty() {
      return _.isEmpty(this.votes);
    }
  },
  methods: {
    ...mapActions('questions', ['updateAbstainOption']),
    trackOption(option) {
      let newOption = option;
      if (
        this.type === 'simple-vote' &&
        option ===
          'I abstain from voting and my proxy shall not vote on this matter'
      ) {
        newOption = 'I choose not to vote';
      }
      this.updateSelection(newOption);
      this.$emit('accept-option-modal');
    },
    updateSelection(option) {
      this.updateAbstainOption({
        questionId: this.questionId,
        option: [option]
      });
    },
    // close modal if background is clicked
    closeModal(event) {
      if (event.target.id === 'wrapper') {
        this.$emit('close-modal');
      }
    },
    // Handle modal button closing
    closeModalButton() {
      this.$emit('close-modal');
    }
  },
  data() {
    return {
      path: this.$route.path.split('?')[0]
    };
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 75vw;
  max-height: 80vh;
  margin: 0px auto;
  padding: 5%;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
}
.modal-buttons {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
/* Transitions */
.modal-enter,
.modal-leave {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.option-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
</style>
